import { useState } from 'react'
import { Chart } from 'primereact/chart'
import { useTranslation } from 'react-i18next'

import SwitchButtonComponent from '../../chart-components/single-selection-button/SwitchButtonComponent'
import { FullnessItems } from 'types/DashboardType'

const FullnessStackedChart = (props: { colors: string[]; response: FullnessItems; userInfo: any }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<any>(t('dashboard.count'))

  const addEmptyLabels = (array: any) => {
    const maxCount = props.userInfo === 'LocationAdmin' ? 10 : 6
    if (array && array.length > 0 && array.length < 5) {
      for (let i = 0; i < maxCount - array.length; i++) {
        array.push('')
      }
    }

    return array
  }
  const labels = addEmptyLabels(props.response?.stackedItems?.labels)

  const stackedData = {
    labels: labels,
    datasets: [
      {
        type: 'bar',
        label: t('dashboard.coming'),
        backgroundColor: props.colors[0],
        data:
          selected === t('dashboard.percentage')
            ? props.response?.stackedItems.percentage[0]
            : props.response?.stackedItems.count[0],
      },
      {
        type: 'bar',
        label: t('dashboard.not-coming'),
        backgroundColor: props.colors[1],
        data:
          selected === t('dashboard.percentage')
            ? props.response?.stackedItems.percentage[1]
            : props.response?.stackedItems.count[1],
      },
    ],
  }
  let stackedOptions = {
    datasets: {
      bar: {
        barThickness: 'flex',
        barPercentage: 0.7,
        categoryPercentage: 1,
      },
    },
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#495057',
          minRotation: 90,
          font: {
            family: "'Inter', serif",
            size: 12,
          },
        },
        grid: {
          color: '#ebedef',
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: '#495057',
        },
        grid: {
          color: '#ebedef',
        },
      },
    },
  }

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            marginLeft: '1rem',
            fontStyle: 'italic',
          }}>
          <span style={{ marginRight: '2rem', fontWeight: 'bold', fontSize: '1rem' }}>
            {selected === 'Yüzde' && '%'}{' '}
          </span>

          <span className="d-block ml-3">{t('dashboard.shared-occupancy-tooltip')}</span>
        </div>

        <div style={{ display: 'flex' }}>
          <SwitchButtonComponent selected={selected} setSelected={setSelected} unselectable={false} />
        </div>
      </div>
      <div className="scroll">
        <Chart
          type="bar"
          data={stackedData}
          className={'stacked-chart'}
          options={stackedOptions}
          style={
            props.userInfo !== 'LocationAdmin'
              ? {
                  width: `${props.response?.stackedItems.labels.length * 100}px`,
                }
              : {
                  width: `${props.response?.stackedItems && props.response?.stackedItems.labels.length * 205}px`,
                }
          }
        />
      </div>
    </div>
  )
}

export default FullnessStackedChart
